export default "__VITE_ASSET__gQ72PmdM__"